import React from 'react'
import { GraphQLClient, ClientContext } from 'graphql-hooks'

const params = {
  url: `https://${process.env.GATSBY_SANITY_PROJECT_ID}.apicdn.sanity.io/v1/graphql/${process.env.GATSBY_SANITY_DATASET}/default`
}

const client = new GraphQLClient(params)

export default ClientContext

export const Provider = ({ children }) => (
  <ClientContext.Provider value={client}>{children}</ClientContext.Provider>
)
